// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3377 ? "2471753b" : chunkId) + "." + {"1975":"1e842f505f09ea28","3377":"b58e1c446e383150"}[chunkId] + ".js";
};